import { createContext, useContext } from "react";

export type ToastTone = "success" | "error" | "info";

export interface ToastEntry {
  id: number;
  message: string;
  tone: ToastTone;
}

export interface ToastApi {
  success: (message: string) => void;
  error: (message: string) => void;
  info: (message: string) => void;
}

export const ToastContext = createContext<ToastApi | null>(null);

export function useToast() {
  const context = useContext(ToastContext);
  if (!context) throw new Error("useToast must be used inside ToastProvider");
  return context;
}
